import axiosConfig from "./axiosConfig";

export interface NextBillingRunResponse {
  // ISO YYYY-MM-DD of the next automatic billing run for this site, resolved
  // for the site's country. Operational PV sites (the only ones with the
  // billing button) always have a country, so this is always present.
  nextRunDate: string;
}

const getSiteNextBillingRun = async (
  authToken: string,
  siteId: string
): Promise<NextBillingRunResponse> => {
  const { data } = await axiosConfig.get(`/site/${siteId}/next-billing-run`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getSiteNextBillingRun;
